import React from 'react';
import { Grid } from '@mui/material';

import {
  BarChartSimpleMobile,
  BarChartStackedMobile,
  BarChartStackedSplitMobile,
} from '../../../BarChart/BarChart';
import { LineChartDetailMobile } from '../../../LineChart/LineChart';
import { ScatterChartSimpleMobile } from '../../../ScatterChart/ScatterChart';
import { MapVlaanderenInteractieveMobile } from '../../../Map/Map';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '../../../Tooltip/Tooltip';
import { DetailTableMobile } from '../../../DetailTable/DetailTable';

export const SimpleBarchartNoGroups = (props: any) => {
  const {
    detailData,
    selectedBenchmarks,
    stackedBarData,
    opties,
    colorsBar,
    locale,
  } = props;

  return (
    <Grid container justifyContent="center">
      <Grid
        className={'vl-typography'}
        item
        xs={12}
        sx={{
          minWidth: '200px !important',
          maxWidth: '800px !important',

          margin: '12px',
          padding: '6px !important',
          marginTop: '32px',
          border: '1px solid #dddddd',
          borderRadius: 2,
        }}
      >
        <h5 className="page-title-mobile" style={{ marginBottom: 0 }}>
          Meest recente situatie ({detailData?.maxJaar})
        </h5>
        {/* <p className="page-subtitle">
      Vergelijking tussen de gekozen gemeenten
    </p> */}

        <Grid
          className={'vl-typography'}
          item
          xs={12}
          height={40 * (selectedBenchmarks.length + 1) + 60}
          sx={{
            minWidth: '200px !important',
            maxWidth: '800px !important',
            paddingTop: '20px',
          }}
        >
          <BarChartSimpleMobile
            data={stackedBarData}
            // stacks={gemeenten}
            keysInStack={opties}
            colors={colorsBar}
            locale={locale}
            survey={detailData?.detail?.survey === '0' ? false : true}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export const SpreidingGemeenten = (props: any) => {
  const { detailData, selectedBenchmarks, spreidingData, locale } = props;

  return (
    <Grid container justifyContent="center">
      <Grid
        className={'vl-typography'}
        item
        xs={12}
        sx={{
          minWidth: '200px !important',
          maxWidth: '800px !important',

          margin: '12px',
          padding: '6px !important',
          marginTop: '32px',
          border: '1px solid #dddddd',
          borderRadius: 2,
        }}
      >
        <h5 className="page-title-mobile" style={{ marginBottom: 0 }}>
          Spreiding van alle gemeenten en het Vlaams Gewest (
          {detailData.maxJaar})
        </h5>
        {/* <p className="page-subtitle">
      Vergelijking tussen de gekozen gemeenten
    </p> */}

        <Grid
          className={'vl-typography'}
          item
          xs={12}
          height={120}
          sx={{
            minWidth: '200px !important',
            maxWidth: '800px !important',
            paddingTop: '20px',
          }}
        >
          <ScatterChartSimpleMobile
            data={spreidingData}
            locale={locale}
          ></ScatterChartSimpleMobile>
        </Grid>
      </Grid>
    </Grid>
  );
};

export const EvolutieChartTabel = (props: any) => {
  const {
    selectedBenchmarks,
    lineChartData,
    scatterShartOneDimensionalProps,
    colorsLine,
    tableData,
    jaren,
    locale,
  } = props;

  return (
    <Grid container justifyContent="center">
      <Grid
        container
        sx={{
          minWidth: '200px !important',
          maxWidth: '800px !important',
          border: '1px solid #dddddd',
          borderRadius: 2,
          marginLeft: '12px',
          marginRight: '12px',
          marginTop: '32px',
          padding: '6px !important',
        }}
      >
        <Grid
          className={'vl-typography'}
          item
          xs={12}
          sx={{
            minWidth: '200px !important',
            paddingLeft: '32px',
            paddingRight: '32px',
          }}
        >
          <h5 className="page-title-mobile" style={{ marginBottom: 0 }}>
            Evolutie
          </h5>
          {/* <p className="page-subtitle">Evolutie van de gemeenten</p> */}

          <Grid
            className={'vl-typography'}
            item
            xs={12}
            height={350}
            sx={{
              minWidth: '200px !important',
              paddingTop: '20px',
            }}
          >
            <LineChartDetailMobile
              data={lineChartData}
              idField={'joinKey'}
              visualProps={scatterShartOneDimensionalProps}
              colors={colorsLine}
              locale={locale}
            ></LineChartDetailMobile>
          </Grid>
          <Grid
            className={'vl-typography'}
            item
            xs={12}
            height={130 + (selectedBenchmarks.length + 1) * 36 + 'px'}
            sx={{
              minWidth: '200px !important',
              paddingTop: '20px',
              paddingBottom: '32px',
            }}
          >
            <DetailTableMobile data={tableData} jaren={jaren} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export const KaartGemeenten = (props: any) => {
  const {
    detailData,
    clusterData,
    clusterDataDesc,
    clusterColorsInteractieve,
  } = props;

  const clusterDataNoNull = clusterData.filter((d: any) => {
    return d.waarde !== null;
  });

  return (
    <Grid container justifyContent="center">
      <Grid
        className={'vl-typography'}
        item
        xs={12}
        sx={{
          minWidth: '200px !important',
          maxWidth: '800px !important',

          margin: '12px',
          padding: '6px !important',
          marginTop: '32px',
          border: '1px solid #dddddd',
          borderRadius: 2,
        }}
      >
        <h5 className="page-title-mobile" style={{ marginBottom: 0 }}>
          Alle gemeenten op kaart ({detailData.maxJaar})
        </h5>
        {/* <p className="page-subtitle">
        Vergelijking tussen de gekozen gemeenten
      </p> */}

        <Grid container>
          <Grid
            className={'vl-typography'}
            item
            xs={12}
            height={120}
            sx={{
              minWidth: '200px !important',
              paddingTop: '20px',
            }}
          >
            <svg
              style={{
                width: '100%',
                height: '100%',
              }}
            >
              {clusterDataDesc.map((d: any, i: number) => {
                return (
                  <g>
                    <rect
                      x={10}
                      y={5 + i * 16}
                      width={10}
                      height={10}
                      fill={clusterColorsInteractieve[i]}
                    />
                    <text
                      x={24}
                      y={10 + i * 16}
                      fill="#111"
                      textAnchor="start"
                      dominantBaseline="middle"
                      fontSize={'11px'}
                      transform="translate(6, 0)"
                    >
                      {d.clusterDesc}
                    </text>
                  </g>
                );
              })}
            </svg>
          </Grid>
          <Grid
            className={'vl-typography'}
            item
            xs={12}
            maxHeight={300}
            sx={{
              minWidth: '200px !important',
              paddingTop: '20px',
            }}
          >
            <MapVlaanderenInteractieveMobile
              data={clusterDataNoNull}
              // selectedCluster={selectedCluster}
            ></MapVlaanderenInteractieveMobile>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export const GemeenteDropdown = (props: any) => {
  const {
    gemeenten,
    onChangeOptieGemeenteHandler,
    selectedOptieGemeente,
    offsetTop,
  } = props;

  return (
    <div
      className="vl-form-col--12-12"
      style={{
        height: '28px',
        position: 'sticky',
        top: offsetTop - 1 + 'px',
        backgroundColor: '#fff',
        zIndex: 10,
      }}
    >
      <select
        name="city"
        className="vl-select vl-select--block noOutline"
        tabIndex={0}
        data-vl-select=""
        data-vl-select-search-empty-text="Geen resultaten gevonden"
        onChange={onChangeOptieGemeenteHandler}
        style={{ fontSize: '11px', lineHeight: '15px', height: '28px' }}
      >
        {gemeenten.map((d: any, i: number) => (
          <option
            key={d}
            value={JSON.stringify(d)}
            selected={d === selectedOptieGemeente}
          >
            <span>{d}</span>
          </option>
        ))}
      </select>
    </div>
  );
};

export const OptiesDropdown = (props: any) => {
  const { opties, onChangeOptieHandler, selectedOptie, offsetTop } = props;

  return (
    <div
      className="vl-form-col--12-12"
      style={{
        height: '28px',
        position: 'sticky',
        top: offsetTop - 1 + 'px',
        backgroundColor: '#fff',
        zIndex: 10,
      }}
    >
      <select
        name="topics"
        className="vl-select vl-select--block noOutline"
        tabIndex={0}
        data-vl-select=""
        data-vl-select-search-empty-text="Geen resultaten gevonden"
        onChange={onChangeOptieHandler}
        style={{ fontSize: '11px', lineHeight: '15px', height: '28px' }}
      >
        {opties.map((d: any, i: number) => {
          return (
            <option
              key={d}
              value={JSON.stringify(d)}
              selected={d === selectedOptie}
            >
              {d}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export const BarChartGrouped = (props: any) => {
  const {
    detailData,
    selectedBenchmarks,
    stackedBarData,
    gemeenten,
    opties,
    colorsBar,
    locale,
    extraId = 0,
  } = props;

  return (
    <Grid container justifyContent="center" style={{ padding: 0 }}>
      <Grid
        className={'vl-typography'}
        item
        xs={12}
        sx={{
          minWidth: '200px !important',
          maxWidth: '800px !important',

          // margin: '12px',
          padding: '6px !important',
          // paddingLeft: '32px',
          // paddingRight: '32px',
          paddingTop: '24px',
          marginTop: '32px',
          border: '1px solid #dddddd',
          borderRadius: 2,
        }}
      >
        <h5 style={{ marginBottom: 0 }}>
          {(extraId === -1 || detailData?.detail?.absValues === false) &&
            'Meest recente situatie'}
          {extraId === 0 &&
            detailData?.detail?.absValues === true &&
            'Meest recente situatie in relatieve cijfers'}
          {extraId > 0 &&
            detailData?.detail?.absValues === true &&
            'Meest recente situatie in absolute cijfers'}{' '}
          ({detailData?.maxJaar})
        </h5>
        {extraId > 0 && detailData?.detail?.absValues === true && (
          <p className="detailPage-subtitle-mobile">
            {detailData?.detail?.absDefinitie}
          </p>
        )}

        <Grid
          className={'vl-typography'}
          item
          xs={12}
          height={
            20 * opties.length * gemeenten.length +
            60 +
            (opties.length > 9
              ? 200
              : opties.length > 6
              ? 140
              : opties.length > 3
              ? 90
              : 48)
          }
          sx={{
            minWidth: '200px !important',
            maxWidth: '800px !important',
            paddingTop: '20px',
          }}
        >
          <BarChartStackedSplitMobile
            data={stackedBarData}
            stacks={gemeenten}
            keysInStack={opties}
            colors={colorsBar}
            locale={locale}
            survey={detailData?.detail?.survey === '0' ? false : true}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export const BarChartStackedGrouped = (props: any) => {
  const {
    detailData,
    selectedBenchmarks,
    stackedBarData,
    gemeenten,
    opties,
    colorsBar,
    locale,
  } = props;

  return (
    <Grid container justifyContent="center">
      <Grid
        className={'vl-typography'}
        item
        xs={12}
        sx={{
          minWidth: '200px !important',
          maxWidth: '800px !important',

          margin: '12px',
          padding: '6px !important',
          paddingTop: '24px',
          marginTop: '32px',
          border: '1px solid #dddddd',
          borderRadius: 2,
        }}
      >
        <h5 className="page-title-mobile" style={{ marginBottom: 0 }}>
          Meest recente situatie ({detailData?.maxJaar})
        </h5>

        <Grid
          className={'vl-typography'}
          item
          xs={12}
          height={
            44 * gemeenten.length +
            90 +
            (opties.length > 9
              ? 200
              : opties.length > 6
              ? 140
              : opties.length > 3
              ? 90
              : 48)
          }
          sx={{
            minWidth: '200px !important',
            maxWidth: '800px !important',
            paddingTop: '20px',
          }}
        >
          <BarChartStackedMobile
            data={stackedBarData}
            stacks={gemeenten}
            keysInStack={opties}
            colors={colorsBar}
            locale={locale}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export const SpreidingGemeentenGrouped = (props: any) => {
  const { detailData, selectedBenchmarks, spreidingData, locale } = props;

  return (
    <Grid
      className={'vl-typography'}
      item
      xs={12}
      sx={{
        minWidth: '200px !important',
        marginBottom: '12px',
        padding: '6px !important',
        paddingTop: '24px',
        marginTop: '32px',
        border: '1px solid #dddddd',
        borderRadius: 2,
      }}
    >
      <h5 className="page-title-mobile" style={{ marginBottom: 0 }}>
        Spreiding van alle gemeenten en het Vlaams Gewest ({detailData.maxJaar})
      </h5>

      <Grid
        className={'vl-typography'}
        item
        xs={12}
        height={120}
        sx={{
          minWidth: '200px !important',
          maxWidth: '800px !important',
          paddingTop: '20px',
        }}
      >
        <ScatterChartSimpleMobile
          data={spreidingData}
          locale={locale}
        ></ScatterChartSimpleMobile>
      </Grid>
    </Grid>
  );
};

export const SimpleBarchartGrouped = (props: any) => {
  const {
    detailData,
    selectedBenchmarks,
    stackedBarData,
    opties,
    colorsBar,
    locale,
  } = props;

  return (
    <Grid
      className={'vl-typography'}
      item
      xs={12}
      sx={{
        minWidth: '200px !important',
        marginBottom: '12px',
        padding: '6px !important',
        paddingTop: '24px',
        marginTop: '32px',
        border: '1px solid #dddddd',
        borderRadius: 2,
      }}
    >
      <h5 className="page-title-mobile" style={{ marginBottom: 0 }}>
        Meest recente situatie ({detailData?.maxJaar})
      </h5>
      {/* <p className="page-subtitle">
        Vergelijking tussen de gekozen gemeenten
      </p> */}

      <Grid
        className={'vl-typography'}
        item
        xs={12}
        height={40 * (selectedBenchmarks.length + 1) + 60}
        sx={{
          minWidth: '200px !important',
          maxWidth: '800px !important',
          paddingTop: '20px',
        }}
      >
        <BarChartSimpleMobile
          data={stackedBarData}
          // stacks={gemeenten}
          keysInStack={opties}
          colors={colorsBar}
          locale={locale}
          survey={detailData?.detail?.survey === '0' ? false : true}
        />
      </Grid>
    </Grid>
  );
};

export const EvolutieChartGemeenten = (props: any) => {
  const {
    lineChartDataGemeente,
    scatterShartOneDimensionalPropsGemeente,
    colorsLineGemeente,

    locale,
    extraId = 0,
  } = props;

  return (
    <Grid
      className={'vl-typography'}
      item
      xs={12}
      sx={{
        minWidth: '200px !important',
        marginBottom: '12px',
        padding: '6px !important',
        paddingTop: '24px',
        marginTop: '32px',
        border: '1px solid #dddddd',
        borderRadius: 2,
      }}
    >
      <h5 className="page-title-mobile" style={{ marginBottom: 0 }}>
        Evolutie in {extraId === 0 ? 'relatieve' : 'absolute'} cijfers
      </h5>
      {extraId > 0 && (
        <p className="detailPage-subtitle-mobile">
          {lineChartDataGemeente[0]?.absDefinitie}
        </p>
      )}

      <Grid
        className={'vl-typography'}
        item
        xs={12}
        height={
          300 +
          (scatterShartOneDimensionalPropsGemeente.length > 9
            ? 200
            : scatterShartOneDimensionalPropsGemeente.length > 6
            ? 140
            : scatterShartOneDimensionalPropsGemeente.length > 3
            ? 90
            : 48)
        }
        sx={{
          minWidth: '200px !important',
          maxWidth: '800px !important',
          paddingTop: '20px',
        }}
      >
        <LineChartDetailMobile
          data={lineChartDataGemeente}
          idField={'joinKey'}
          visualProps={scatterShartOneDimensionalPropsGemeente}
          colors={colorsLineGemeente}
          locale={locale}
        ></LineChartDetailMobile>
      </Grid>
    </Grid>
  );
};

export const EvolutieChartGemeentenAbs = (props: any) => {
  const {
    lineChartDataGemeente,
    scatterShartOneDimensionalPropsGemeente,
    colorsLineGemeente,
    detailData,
    locale,
    gemeenten,
    onChangeOptieGemeenteHandler,
    selectedOptieGemeente,
  } = props;

  return (
    <Grid container justifyContent="center">
      <Grid
        id={'EvolutieChartGemeentenAbs_' + detailData?.detail?.ido}
        className={'vl-typography'}
        item
        xs={12}
        sx={{
          minWidth: '200px !important',
          maxWidth: '800px !important',

          marginBottom: '12px',
          padding: '6px !important',
          paddingTop: '24px',
          marginTop: '32px',
          border: '1px solid #dddddd',
          borderRadius: 2,
        }}
      >
        <Grid container>
          <Grid item xs={12}>
            <h5 className="page-title-mobile" style={{ marginBottom: 0 }}>
              Evolutie in absolute cijfers
            </h5>
            <p className="detailPage-subtitle-mobile">
              {lineChartDataGemeente[0]?.absDefinitie}
            </p>
          </Grid>
        </Grid>

        <br />
        <GemeenteDropdown
          gemeenten={gemeenten}
          onChangeOptieGemeenteHandler={onChangeOptieGemeenteHandler}
          selectedOptieGemeente={selectedOptieGemeente}
        />

        <Grid
          className={'vl-typography'}
          item
          xs={12}
          height={350}
          sx={{
            minWidth: '200px !important',
            maxWidth: '800px !important',
            paddingTop: '20px',
          }}
        >
          <LineChartDetailMobile
            data={lineChartDataGemeente}
            idField={'joinKey'}
            visualProps={scatterShartOneDimensionalPropsGemeente}
            colors={colorsLineGemeente}
            locale={locale}
          ></LineChartDetailMobile>
        </Grid>
      </Grid>
    </Grid>
  );
};

export const EvolutieChartTabelGrouped = (props: any) => {
  const {
    selectedBenchmarks,
    lineChartData,
    scatterShartOneDimensionalProps,
    colorsLine,
    tableData,
    jaren,
    locale,
  } = props;

  return (
    <Grid
      className={'vl-typography'}
      item
      xs={12}
      sx={{
        minWidth: '200px !important',
        marginBottom: '12px',
        padding: '6px !important',
        paddingTop: '24px',
        marginTop: '32px',
        border: '1px solid #dddddd',
        borderRadius: 2,
      }}
    >
      <h5 className="page-title-mobile" style={{ marginBottom: 0 }}>
        Evolutie
      </h5>
      {/* <p className="page-subtitle">Evolutie van de gemeenten</p> */}

      <Grid
        className={'vl-typography'}
        item
        xs={12}
        height={350}
        sx={{
          minWidth: '200px !important',
          maxWidth: '800px !important',
          paddingTop: '20px',
        }}
      >
        <LineChartDetailMobile
          data={lineChartData}
          idField={'joinKey'}
          visualProps={scatterShartOneDimensionalProps}
          colors={colorsLine}
          locale={locale}
        ></LineChartDetailMobile>
      </Grid>
      <Grid
        className={'vl-typography'}
        item
        xs={12}
        height={(selectedBenchmarks.length + 1) * 36 + 52 + 80}
        sx={{
          minWidth: '200px !important',
          paddingTop: '20px',
          paddingBottom: '32px',
        }}
      >
        <DetailTableMobile data={tableData} jaren={jaren} />
      </Grid>
    </Grid>
  );
};

export const KaartGemeentenGrouped = (props: any) => {
  const {
    detailData,
    clusterData,
    clusterDataDesc,
    clusterColorsInteractieve,
  } = props;

  const clusterDataNoNull = clusterData.filter((d: any) => {
    return d.waarde !== null;
  });

  return (
    <Grid
      className={'vl-typography'}
      item
      xs={12}
      sx={{
        marginBottom: '12px',
        padding: '6px !important',
        paddingTop: '24px',
        marginTop: '32px',
        border: '1px solid #dddddd',
        borderRadius: 2,
        minWidth: '200px !important',
        maxWidth: '800px !important',
      }}
    >
      <h5 className="page-title-mobile" style={{ marginBottom: 0 }}>
        Alle gemeenten op kaart ({detailData.maxJaar})
      </h5>

      <Grid container>
        <Grid
          className={'vl-typography'}
          item
          xs={12}
          height={120}
          sx={{
            minWidth: '200px !important',
            paddingTop: '20px',
          }}
        >
          <svg
            style={{
              width: '100%',
              height: '100%',
            }}
          >
            {clusterDataDesc.map((d: any, i: number) => {
              return (
                <g>
                  <rect
                    x={10}
                    y={5 + i * 16}
                    width={10}
                    height={10}
                    fill={clusterColorsInteractieve[i]}
                  />
                  <text
                    x={24}
                    y={10 + i * 16}
                    fill="#111"
                    textAnchor="start"
                    dominantBaseline="middle"
                    fontSize={'11px'}
                    transform="translate(6, 0)"
                  >
                    {d.clusterDesc}
                  </text>
                </g>
              );
            })}
          </svg>
        </Grid>
        <Grid
          className={'vl-typography'}
          item
          xs={12}
          maxHeight={300}
          sx={{
            minWidth: '200px !important',
            paddingTop: '20px',
          }}
        >
          <MapVlaanderenInteractieveMobile
            data={clusterDataNoNull}
            // selectedCluster={selectedCluster}
          ></MapVlaanderenInteractieveMobile>
        </Grid>
      </Grid>
    </Grid>
  );
};
